// extracted by mini-css-extract-plugin
export default {"warnBox":"WarningBox_warnBox__aChxR","title":"WarningBox_title__CxWKs","detail":"WarningBox_detail__K81nj"};